import React from "react";
import styles from "./index.module.css";
import Button from "../../../Components/Button";
import { FaWheelchair } from "react-icons/fa6";
import { QrScan } from "../../../FigmaIcons/QrScan";
import { CANCEL_STATUS } from "../constants";
import { MdClose } from "react-icons/md";

const ActionButtons = ({ status, toggleCancel }) => (
  <div className={styles["patient-transport__button--group"]}>
    {/* {status === "shifter_accepted" && (
      <>
        <Button type="button" coolGreyButton roundedButton>
          <FaWheelchair size={22} color="#2C4861" />
        </Button>
        <Button type="button" coolGreyButton roundedButton>
          <QrScan size={32} color="#2C4861" />
        </Button>
      </>
    )} */}
    {CANCEL_STATUS?.includes(status) && (
      <Button type="button" coolGreyButton roundedButton onClick={toggleCancel}>
        <MdClose size={32} color="#9F282F" />
      </Button>
    )}
  </div>
);

export default ActionButtons;
